BASE_URL =
  process.env.NODE_ENV == "production"
    ? "https://api.copy-wealth.com"
    : "http://100.83.111.76:12701";

_DEFAULT_LANGUAGE_ = "en-US";
